import React, { useState, useEffect } from 'react'
import { Navbar, NavDropdown, Modal, Button, Form, FormGroup, FormControl } from 'react-bootstrap';
import Avatar from 'react-avatar';
import { TbLogout } from "react-icons/tb";
import { MdOutlinePassword } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Header() {
  const navigate = useNavigate();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [userId, setUserId] = useState('');

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser && storedUser.userid) {
      setUserId(storedUser.userid);
    }
  }, []);


  const handleLogout = () => {
    setShowConfirmation(false);
    localStorage.removeItem("token")
    localStorage.clear()
    navigate('/login');
  };


  const handleChangePassword = async () => {
    // Validate form before submitting
    const form = document.getElementById('changePasswordForm');
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }


    if (newPassword !== confirmPassword) {
      alert("New password and confirm password don't match.");
      return;
    }



    const data = {
      "UserId": userId, // Pass the userId here
      "OldPassword": password,
      "NewPassword": newPassword,
      "ReTypePassword": confirmPassword,

    }
    console.log(data);
    try {
      const response = await axios.post('https://154.61.77.24:8009/ChangePassword', data)
      console.log(response);
    }
    catch (error) {
      console.error(error);
    }
  };
  const Logostyle = {
    height: "40px",
    width: "100%",
    maxwidth: "100%",
    marginBottom: "20px",
    marginTop: "10px",
  };
  return (
    <Navbar style={{ backgroundColor: '#172446', height: '50px' }} expand="lg">
      <Navbar.Brand href="#home" style={{ color: "white" }}>
        <img
          src={process.env.PUBLIC_URL + "/assets/images/HeaderLogo.png"}
          style={Logostyle}
          alt=""
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">

      </Navbar.Collapse>
      <NavDropdown title={
        (<Avatar
          round
          size="30"
          name="John Doe"
          style={{ marginRight: '17px' }}
          src="https://example.com/avatar.jpg"
          color='#FFE114'
          fgColor="#172446"
        />)
      }
        id="basic-nav-dropdown"
        drop="start"
      >
        <div>

          <NavDropdown.Item href="#action/3.1"
            style={{ fontWeight: 600, fontFamily: 'segoe ui' }}
            onClick={() => setShowChangePassword(true)}
          >
            <MdOutlinePassword />  Change Password
          </NavDropdown.Item>
          <NavDropdown.Item href="#action/3.2"
            style={{ fontWeight: 600, fontFamily: 'segoe ui' }}
            onClick={() => setShowConfirmation(true)}
          >
            <TbLogout />  Logout
          </NavDropdown.Item>
        </div>

      </NavDropdown>


      {/* Change Password Modal */}
      <Modal show={showChangePassword} onHide={() => setShowChangePassword(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="changePasswordForm" noValidate validated={validated}>
            <FormGroup controlId="Password">
              <Form.Label>Current Password</Form.Label>
              <FormControl
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">Please enter your current password.</Form.Control.Feedback>
            </FormGroup>
            <FormGroup controlId="newPassword">
              <Form.Label>New Password</Form.Label>
              <FormControl
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">Please enter a new password.</Form.Control.Feedback>
            </FormGroup>
            <FormGroup controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <FormControl
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">Please confirm your new password.</Form.Control.Feedback>
            </FormGroup>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" style={{ fontWeight: 600, fontFamily: 'segoe ui', color: 'black', border: 'none' }} onClick={() => setShowChangePassword(false)}>
            Cancel
          </Button>
          <Button style={{ fontWeight: 600, fontFamily: 'segoe ui', color: 'white', backgroundColor: '#172446', border: 'none' }} onClick={handleChangePassword}>
            Change Password
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Confirmation Dialog */}
      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontWeight: 600, fontFamily: 'segoe ui', color: 'black' }}>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" style={{ fontWeight: 600, fontFamily: 'segoe ui', color: 'black', border: 'none' }} onClick={() => setShowConfirmation(false)}>No</Button>
          <Button style={{ fontWeight: 600, fontFamily: 'segoe ui', color: 'white', backgroundColor: '#172446', border: 'none' }} onClick={handleLogout}>Yes</Button>
        </Modal.Footer>
      </Modal>

    </Navbar>


  )
}

export default Header